import appConfig from '../config/app-config';

interface ApiConfig {
    apiUrl: string;
    endpoints: {
        businessAreas: string;
        rules: string;
        toggle: string;
        pldReports: string;
        pldReportsCheck: string;
    };
    authentication: {
        type: string;
        headerName: string;
        apiKey: string;
    };
}

class ConfigService {
    private config: ApiConfig | null = null;

    getConfig(): ApiConfig {
        if (this.config) {
            return this.config;
        }

        // Configuração baseada em variáveis de ambiente seguindo padrão do backoffice
        const recommendationApi = appConfig.apis.recommendationEngineApiEnv;
        const baseApiUrl = (recommendationApi.address || '').replace(/\/$/, '');

        if (!baseApiUrl) {
            console.error('REACT_APP_RECOMMENDATION_API_URL não configurada. Configure no arquivo .env');
        }

        const apiKey = recommendationApi.key;

        if (!apiKey) {
            console.error('REACT_APP_RECOMMENDATION_API_KEY não configurada. Configure no arquivo .env');
        }

        this.config = {
            apiUrl: baseApiUrl,
            endpoints: {
                businessAreas: '/recommendations/business-areas',
                rules: '/rules',
                toggle: '/rules/{id}/toggle',
                pldReports: '/pld-reports',
                pldReportsCheck: '/pld-reports/check'
            },
            authentication: {
                type: 'API_KEY',
                headerName: 'x-api-key',
                apiKey: apiKey
            }
        };

        return this.config;
    }

    // Método para limpar cache (útil para testes)
    clearCache(): void {
        this.config = null;
    }
}

export const configService = new ConfigService();
export type { ApiConfig };
